import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasHeating = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_heating')(jsonQuery));
